import { EmphasisCatalog } from '../catalogs/catalog.types';

interface HasEmphasisCatalogChangesParams {
  selectedCatalogs: EmphasisCatalog[];
  savedCatalogs: EmphasisCatalog[];
}

export const hasEmphasisCatalogChanges = ({
  selectedCatalogs,
  savedCatalogs,
}: HasEmphasisCatalogChangesParams) => {
  if (selectedCatalogs.length !== savedCatalogs.length) {
    return true;
  }

  return selectedCatalogs.some(
    (selectedCatalog, index) => selectedCatalog.catalog.id !== savedCatalogs[index].catalog.id,
  );
};
